import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrl: './rating.component.scss'
})
export class RatingComponent implements OnInit {
  @Input() ratingCount: number = 5;
  @Input() rating!: number;
  @Input() isEditable: boolean = false;
  @Input() starSize: number = 24;

  @Output() ratingChange: EventEmitter<number> = new EventEmitter<number>();

  protected stars: number[] = [];

  ngOnInit(): void {
    if (this.rating > this.ratingCount) {
      this.rating = this.ratingCount;
    }
    this.stars = Array(this.ratingCount).fill(0);
  }

  protected setRating(newRating: number): void {
    if (this.isEditable) {
      this.rating = newRating;
      this.ratingChange.emit(newRating);
      this.stars = Array(this.ratingCount).fill(0).map((_, i) => i < this.rating ? 1 : 0);
    }
  }
}
